import request from "@/utils/request";

export function getVehicleTypeList(params) {
    return request({
        url: '/settings/vehicleType/list',
        method: "get",
        params: params
    });
}